export const INITIAL_PRIVACY_POLICY = "INITIAL_PRIVACY_POLICY";
export const INITIAL_APP_POLICY = "INITIAL_APP_POLICY";